// extracted by mini-css-extract-plugin
export default {"container":"container-BPxwfHss","containerInner":"containerInner-GX8TXg_Q","hasFooter":"hasFooter-ITAwfeQB","extraFooterContainer":"extraFooterContainer-idiyTvfy"};